import './admin.css';

function Admin(){

    return(
        <div className="admincountainer">

            <div className="adminav">
                <h2>Admin Dashboard</h2>

                <div className="logout">
                    <button className="logoutbtn">
                        Logout
                        <span className="material-symbols-outlined">
                            logout
                        </span>
                    </button>
                </div>

            </div>

            <hr />

            <div className="stats">

                <div className="statscards">
                    <div className="cardsspan">
                        <h4>Projects</h4>
                        <span className="material-symbols-outlined">
                            work
                        </span>
                    </div>
                    <br/>
                    <h3>4</h3>
                </div>

                <div className="statscards">
                    <div className="cardsspan">
                        <h4>Products</h4>
                        <span className="material-symbols-outlined">
                            package_2
                        </span>
                    </div>
                    <br/>
                    <h3>4</h3>
                </div>

                <div className="statscards">
                    <div className="cardsspan">
                        <h4>Quotes Requested</h4>
                        <span className="material-symbols-outlined">
                            request_quote
                        </span>
                    </div>
                    <br/>
                    <h3>4</h3>
                </div>

                <div className="statscards">
                    <div className="cardsspan">
                        <h4>Inquiries</h4>
                        <span className="material-symbols-outlined">
                            help_center
                        </span>
                    </div>
                    <br/>
                    <h3>4</h3>
                </div>

            </div>

            <div className="functions">

                <div className="fbuttons">
                    <h3>Products</h3>
                </div>

                <div className="fbuttons">
                    <h3>Projects</h3>
                </div>

                <div className="fbuttons">
                    <h3>Quotes</h3>
                </div>

                <div className="fbuttons">
                    <h3>Inquiries</h3>
                </div>

            </div>

        </div>
    )
}

export default Admin;